import React from 'react';
import styles from './Bullet.module.scss';

interface BulletProps {
  className: string;
  children: React.ReactNode;
  caption: string;
  onClick: () => void;
  order?: number;
}

function Bullet({
  className,
  children,
  caption,
  onClick,
  order,
}: BulletProps): JSX.Element {
  return (
    <div className={styles.container}>
      <button
        type="button"
        onClick={onClick}
        aria-label={`Etapa ${order} ${caption}`}
        className={`${styles.bullet} ${className}`}
      >
        <span>{children}</span>
      </button>
      <span aria-hidden>{caption}</span>
    </div>
  );
}

export default Bullet;
